@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as m;
@use "styles/abstracts/variables" as v;

$grid-cols: 260px 120px 120px 120px 115px 145px 170px 1fr;
$grid-cols-scroll: 260px 120px 120px 120px 115px 145px 170px 72px;
$table-min-width: 1122px;

.table {
    margin-bottom: 16px;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    @include m.media(v.$container-desktop, "min") {
        overflow-x: visible;
    }

    .select {
        width: 100%;

        > div {
            border: 1px solid transparent;
        }

        .indicator {
            display: none;
        }

        .optionDelBtn {
            padding: 6px 0;
        }
    }
}

.menu {
    width: 360px;
}

.header {
    display: grid;
    grid-template-columns: $grid-cols-scroll;
    min-width: $table-min-width;
    width: auto;

    @include m.media(v.$container-desktop, "min") {
        grid-template-columns: $grid-cols;
        min-width: 0;
        width: 100%;
    }
}

.headerCell {
    padding: 14px 16px;
    text-align: left;
    white-space: nowrap;
    @include t.text(14px, 22px, 600);
}

.headerCellError {
    color: v.$color-error;
}

.row {
    display: grid;
    grid-template-columns: $grid-cols-scroll;
    min-width: $table-min-width;
    width: auto;
    border-top: 1px solid v.$palette-dirty-20;

    @include m.media(v.$container-desktop, "min") {
        grid-template-columns: $grid-cols;
        min-width: 0;
        width: 100%;
    }
}

.cell {
    display: flex;
    align-items: center;
    padding-right: 2px;
    height: 50px;
    width: 100%;
    min-width: 0;

    &.tdColor {
        padding: 14px 16px;
    }

    &.disable {
        background-color: v.$palette-dirty-20;
    }
}

.actionsBox {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;

    button svg {
        max-width: unset;
    }
}

.numberInput {
    &::placeholder {
        color: v.$palette-dirty-70;
    }

    &.placeholderError::placeholder {
        color: v.$color-error;
    }
}

.saveModal {
    padding: 24px;
    width: 370px;
    max-width: 100%;

    .title {
        margin-bottom: 32px;
        @include t.text(20px, 30px, 600);
    }

    .btns {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 16px;
        margin-top: 32px;
    }
}
